import React from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import { ContentMasteryErrorRateListService } from '../../services/ContentListService';
import { browserHistory } from 'react-router';
import ContentErrorRateTable from '../commons/ContentErrorRateTable';
import PropTypes from 'prop-types';
import { englishLevelCourses } from '../../../../../core/consts';
import { get } from 'lodash';

class ContentMasteryTestErrorRateTableContainer extends React.Component {
  componentDidMount() {
    ContentMasteryErrorRateListService.load(
      this.props.masteryTestId ? 'masteryTest' : this.props.moduleId ? 'module' : 'course',
      this.props.masteryTestId || this.props.moduleId || this.props.courseId
    );
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      this.props.masteryTestId !== prevProps.masteryTestId ||
      this.props.moduleId !== prevProps.moduleId ||
      this.props.courseId !== prevProps.courseId
    ) {
      ContentMasteryErrorRateListService.load(
        this.props.masteryTestId ? 'masteryTest' : this.props.moduleId ? 'module' : 'course',
        this.props.masteryTestId || this.props.moduleId || this.props.courseId
      );
    }
  }

  render() {
    return (
      <ContentErrorRateTable
        loading={
          ContentMasteryErrorRateListService.fetchCurrent.fetching ||
          ContentMasteryErrorRateListService.fetchPrevious.fetching
        }
        values={toJS(ContentMasteryErrorRateListService.getList()).map((item) =>
          Object.assign({}, item, {
            level: get(
              englishLevelCourses.find((c) => c.label === item.name),
              'value',
              null
            ),
          })
        )}
        nameColumnPath={this.props.courseId || this.props.moduleId || this.props.masteryId ? 'order' : 'level'}
        nameColumnRender={(row) => {
          if (this.props.moduleId) {
            return `${row.name}%`;
          } else if (this.props.courseId) {
            return `${row.order} - ${row.name}`;
          } else {
            return row.name;
          }
        }}
        onSelect={(row) => {
          if (this.props.masteryTestId) {
            return false;
          } else if (this.props.moduleId) {
            browserHistory.push(
              `/kpis/content/course/${this.props.courseId}/module/${this.props.moduleId}/mastery-test/${row.id}/mastery-details`
            );
          } else if (this.props.courseId) {
            browserHistory.push(`/kpis/content/course/${this.props.courseId}/module/${row.id}/mastery-details`);
          } else {
            browserHistory.push(`/kpis/content/course/${row.id}/mastery-details`);
          }
        }}
        formatter={ContentMasteryErrorRateListService.getFormattedValue}
        feedbackColorRender={ContentMasteryErrorRateListService.getFeedbackColor}
      />
    );
  }
}

ContentMasteryTestErrorRateTableContainer.propTypes = {
  courseId: PropTypes.string,
  moduleId: PropTypes.string,
  masteryTestId: PropTypes.string,
};

export default observer(ContentMasteryTestErrorRateTableContainer);
